import ThemedComponent from '../../hoc/ThemedComponent';
import PaymentDataPage from './PaymentDataPage';
import { default as PaymentDataPage3 } from '../../themes/3/pages/payment/PaymentDataPage';
import { default as PaymentDataPage4 } from '../../themes/4/pages/payment/PaymentDataPage';

const ThemedPaymentDataPages = {
    default: PaymentDataPage,
    // 3: PaymentDataPage3,
    // 4: PaymentDataPage4,
};

export const ThemedPaymentDataPage = ThemedComponent(ThemedPaymentDataPages);